/** Helper that trims auth related text out of a URL */
export const removeAuthStuffInUrl = (url) => {
    if (!(url === null || url === void 0 ? void 0 : url.replace)) {
        return undefined;
    }
    return (url
        // Remove `/auth`
        .replace(/\/auth/g, '')
        // Replace two or more '/' with a single '/'
        .replace(/\/\/+/g, '/')
        // Re-add double slashes to protocol
        .replace(':/', '://'));
};
